import { adExtension } from './ad-extension';
import { advancedInsights } from './advanced-insights';
import { billing } from './billing';
import { changeHistory } from './change-history';
import { dsa } from './dsa';
import { performance } from './performance';
import { product } from './product';
import { targeting } from './targeting';
import { labels } from './labels';
import { hotel } from './hotel';
import { appAds } from './app';
import { assets } from './assets';
import { marketplaceInsights } from './marketplace-insights';

export const elevatedColumnsMap = {
  ...performance,
  ...adExtension,
  ...advancedInsights,
  ...billing,
  ...changeHistory,
  ...dsa,
  ...product,
  ...targeting,
  ...labels,
  ...hotel,
  ...appAds,
  ...assets,
  ...marketplaceInsights,
};
